import { animate, eases, createSpring } from 'animejs';
export const animation = {
	init: function () {
		this.headerSearch();
	},
	headerSearch: function () {
		if (!window.matchMedia('(max-width: 767.98px)').matches) return;
		const widthLogoOrigin = $('.header-logo').width();
		$(".header-search input").on("focus", function () {
			animate('.header-logo', {
				width: '0',
				duration: 150,
			});
		});
		$(".header-search input").on("blur", function () {
			animate('.header-logo', {
				width: widthLogoOrigin,
				duration: 150,
			});
		});
	},
};